import { createContext, useContext } from 'react';

// SidebarCollapsedContext exposes whether the desktop sidebar rail is collapsed
// so deeply-nested overlays (e.g. WizardDialog) can center over the CONTENT
// area — right of the rail — instead of the full viewport, without threading
// the flag through every intermediate component. Defaults to false so a dialog
// rendered outside the shell (tests, the signup portal) just centers on the
// viewport. Provided by DashboardShell; the rail is 260px expanded / 72px
// collapsed, so the centering offset is half of that (130px / 36px).
export const SidebarCollapsedContext = createContext(false);

export function useSidebarCollapsed(): boolean {
  return useContext(SidebarCollapsedContext);
}
